export enum Colors {
  primary = '#1d2331',
  primaryDark = '#191e2b',
  primaryDarkest = '#0c0e14',
  red = '#f24c3d',
  redDark = '#d32f2f',
  pinkLight = '#fcdee8',
  pink = '#e62265',
  redLight = '#fde4e2',
  purple = '#9c27b0',
  purpleLight = '#f0dff3',
  purpleDark = '#7b1fa2',
  deepPurple = '#512DA8',
  lightDeepPurple = '#e8e2f4',
  deepPurpleDark = '#512da8',
  lightIndigo = '#e2e5f2',
  indigo = '#3f51b5',
  indigoLight = '#e2e5f4',
  indigoDark = '#303f9f',
  blue = '#2196f3',
  blueLight = '#def0fd',
  blueDark = '#1976d2',
  lightBlueLight = '#d9f2fe',
  lightBlue = '#03a9f4',
  lightBlueHeader = '#fbfcfd',
  lightBlueTile = '#f8fcfd',
  paletteLightBlue = '#e3f2fd',
  lightBlueSelect = '#f7fbfd',
  lightBlueDark = '#0288d1',
  lightCyan = '#d9f5f9',
  cyanDark = '#0097a7',
  cyan = '#00bcd4',
  tealLight = '#d9f0ed',
  teal = '#009688',
  tealDark = '#00796b',
  greenLightest = '#f8fbf8',
  greenLight = '#e7f3e7',
  greenLighter = '#e7f5e9',
  green = '#4caf50',
  greenDark = '#388e3c',
  greenActive = '#E6F7E3',
  greenFeatureTile = '#F4FFF0',
  lightGreenLight = '#eef6e4',
  lightGreen = '#8bc34a',
  lightGreenDark = '#689f38',
  limeLight = '#f8fae2',
  lime = '#cddc39',
  limeLightDark = '#afb42b',
  yellowLight = '#fffce2',
  yellow = '#ffeb3b',
  yellowDark = '#fbc02d',
  amberLight = '#fff6da',
  amber = '#ffc107',
  amberDark = '#ffa000',
  veryLightOrange = '#fffaf2',
  orangeLighter = '#fff3e0',
  orangeLight = '#fff0d9',
  orange = '#ff9800',
  orangeDark = '#f57c00',
  deepOrangeLight = '#ffe6de',
  deepOrange = '#ff5722',
  deepOrangeDark = '#e64a19',
  brownLight = '#EFEBE9',
  brown = '#795548',
  brownDark = '#6D4C41',
  darkBrown = '#5d4037',
  primaryLightest = '#7b95cc',
  primaryLight = '#5c7099',
  primaryLightGrey = '#f2f2f2',
  primaryGrey = '#e5e5e5',
  primaryDarkGrey = '#a6a6a6',
  primaryGreyDarkest = '#808080',
  charcoal = '#333333',
  grey2 = '#222222',
  black = '#000000',
  white = '#ffffff',
  tealCatalog = '#26C6DA',
  lightBlueCatalog = '#2AB6F6',
  blueCatalog = '#42A5F5',
  darkBlueCatalog = '#5C6BC0',
  purpleCatalog = '#7E57C2',
  lightPurpleCatalog = '#AB47BC',
  pinkCatalog = '#ED407A',
  redCatalog = '#EF5350',
  orangeCatalog = '#FF7043',
  darkYellowCatalog = '#FFCA27',
  yellowCatalog = '#FFEE59',
  yellowGreenCatalog = '#D4E157',
  lightGreenCatalog = '#9CCC65',
  greenCatalog = '#66BB69',
  darkGreenCatalog = '#26A69A',
  brownCatalog = '#8D6E63',
  skyBlue = '#E3F2FD',
  veryLightPink = '#cccccc',
  greyLight = '#fafafa',
  greyFade = '#969696',
  brandPrimary = '#3023ae',
  brandSecondary = '#c86dd7',
  modalBgColor = 'rgba(0,0,0,0.6)',
  transparent = '#ffffff00',
  whiteTransparent = 'rgba(255, 255, 255, 0.67)',
  warning = '#ffebee',
  blackTransparent01 = 'rgba(0,0,0,0.1)',
  blackTransparent02 = 'rgba(0,0,0,0.2)',
  blackTransparent03 = 'rgba(0,0,0,0.3)',
  redNegative = '#f44336',
  faitOrange = '#fffcf6',
  amberLightest = '#FFC008',
  redLightest = '#FFF9FA',
}

export enum ThemeType {
  DARK = 'dark',
  LIGHT = 'light',
}

export type Theme = {
  dark: boolean;
  logo: string;
  tillWhiteLogo: string;
  spacing: { [variant: string]: number };
  font: { [variant: string]: string };
  colors: { [name: string]: string };
  fontSize: { [variant: string]: number };
  button: { [variant: string]: number };
  radius: { [variant: string]: number };
  border: { [variant: string]: object };
  padding: { [variant: string]: number };
  header: { [variant: string]: number };
  shadow15: { [variant: string]: number | string | object };
  shadow30: { [variant: string]: number | string | object };
  input: { [variant: string]: number };
  font14Regular: { [variant: string]: number | string | object };
  font14Bold: { [variant: string]: number | string | object };
  font14SemiBold: { [variant: string]: number | string | object };
  font14Medium: { [variant: string]: number | string | object };
  font14RegularCharcoal: { [variant: string]: number | string | object };
  font14RegularDarkGrey: { [variant: string]: number | string | object };
  backOfficeSectionTitle: { [variant: string]: number | string | object };
  backOfficeSectionDescription: { [variant: string]: number | string | object };
  footerButtonActionsContainer: { [variant: string]: number | string | object };
  gradient: { [variant: string]: object | Array<number> };
};

export type ThemeMap = {
  [brand: string]: {
    [variant: string]: Theme;
  };
};

export type StyleFnProps = {
  theme: Theme;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  [name: string]: any;
};

export type RenderProps = {
  style: object;
  theme: Theme;
};

export enum Icons {
  Check = 'Check',
  CheckCircle = 'CheckCircle',
  Warning = 'exclamation-triangle',
  Uncheck = 'Uncheck',
  TickMark = 'Tick',
  Delete = 'trash-alt',
  Edit = 'pen',
  Plus = 'Plus',
  Times = 'times',
  AngleRight = 'AngleRight',
  ArrowRight = 'ArrowRight',
  ArrowLeft = 'ArrowLeft',
  Circle = 'circle',
  RecordAudio = 'recordAudio',
  USDCircle = 'usd-circle',
  PlusCircle = 'plus-circle',
  MinusCircle = 'minus-circle',
  Split = 'align-center-h',
  Redo = 'redo',
  Print = 'print',
  InfoCircle = 'info-circle',
  ArrowUp = 'arrow-up',
  ArrowDown = 'arrow-down',
  SquareShape = 'square-shape',
  CheckSquare = 'check-square',
  MinusSquare = 'minus-square',
  SquareFull = 'square-full',
  MinusSquareFull = 'minus-square-full',
  AngleUp = 'angle-up',
  AngleDown = 'angle-down',
  UserCircle = 'user-circle',
  UsersAlt = 'users-alt',
  Clock = 'clock',
  Setting = 'setting',
  Trash = 'Trash',
  Bolt = 'bolt',
  BoltSlash = 'bolt-slash',
  Layers = 'layers',
  DraggableDots = 'draggabledots',
  AngleLeft = 'AngleLeft',
  Star = 'star',
  ExclamationTriangle = 'exclamationTriangle',
  Chat = 'comment-alt-lines',
  ToggleOn = 'toggle-on',
  ToggleOff = 'toggle-off',
  Info = 'exclamation-circle',
  Reward = 'gift',
  Envelop = 'envelope-alt',
}

export type StyleFn = (args: StyleFnProps) => object;
